export default __webpack_public_path__ + "static/media/DocDB.82e8aa98.svg";